import { render } from "./School_Lecture.vue?vue&type=template&id=6fbe314c"
import script from "./School_Lecture.vue?vue&type=script&lang=js"
export * from "./School_Lecture.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__